/*
 * @Author: yuqiuyu 18180464352@163.com
 * @Date: 2022-06-06 15:03:34
 * @LastEditors: yuqiuyu 18180464352@163.com
 * @LastEditTime: 2022-07-20 15:10:01
 * @FilePath: \vueproject-master\src\permission.js
 * @Description:
 *
 * Copyright (c) 2022 by 斯马特有限公司, All Rights Reserved.
 */
import router from "./router";
import store from "./store";
// import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken, getInfo, removeToken } from "@/utils/auth"; // get token from cookie
import getPageTitle from "@/utils/get-page-title";
import { MessageBox, Message } from "element-ui";
// import { initMenu } from "@/utils/permission";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = [
  "/Home",
  "/UserAgreement",
  "/UserAgreement",
  "/AllCourses",
  "/IndustryBBS",
  "/BBSdeatils",
  "/BBSdeatils_s",
  // "/personalCenter",
  "/Posting",
  "/VideoPlayback",
  "/404",
  "/Lis",
  "/Vet"
]; // no redirect whitelist

// 路由导航守卫
router.beforeEach(async (to, from, next) => {
  NProgress.start(); // start progress bar
  // 3、使用路由拦截器，跳转路由调用clearCancel方法，清空存入的信息。终止未请求成功的请求
  store.dispatch("users/clearCancel");
  // set page title
  document.title = getPageTitle(to.meta.title);
  // determine whether the user has logged in
  const hasToken = getToken();
  if (hasToken) {
    /* has token*/
    // if (to.path === "/Home") {
    // if (false) {
    // next();
    // NProgress.done(); // if current page is dashboard will not trigger afterEach hook, so manually handle it
    // } else {
    // console.log(store.getters.userInfo, "得到用户信息");
    // 如果vux里面没有用户信息
    if (!store.getters.userInfo) {
      await store.dispatch("users/resetToken");
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    } else {
      /**
       * 需求迭代2026-02-04
       *没有 权限直接清空token 返回登录页面
       */
      const hasPermission = () => {
        if (!(to.meta && to.meta.PermissionID)) return true;
        return getHasPermission(to.meta.PermissionID);
      };
      // 管理员
      if (store.getters.userInfo.FullID == 1) {
        if (hasPermission) {
          if (
            whiteList.indexOf(to.path) !== -1 ||
            to.path == "/personalCenter"
          ) {
            // 在免登录白名单，全部重定向到管理界面
            next("/CourseManagement");
            NProgress.done();
          } else {
            next();
            NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
          }
          next();
          NProgress.done();
        } else {
          store.dispatch("users/resetToken");
          next("/Home"); // 否则全部重定向到登录页
          NProgress.done();
        }
      } else if (store.getters.userInfo.FullID != 1) {
        if (whiteList.indexOf(to.path) !== -1) {
          // 在免登录白名单，直接进入
          next();
          NProgress.done();
        } else {
          if (hasPermission) {
            next();
            NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
          } else {
            store.dispatch("users/resetToken");
            next("/Home"); // 否则全部重定向到登录页
            NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
          }
        }
      }
    }
  } else {
    /* has no token*/
    console.log(to.path, "没有token");
    if (whiteList.indexOf(to.path) !== -1) {
      // console.log("in");
      // 在免登录白名单，直接进入
      next();
      NProgress.done();
    } else {
      MessageBox.confirm("您还未登录账号，请登录之后使用", {
        confirmButtonText: "登录",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (to.path == "/Home") {
            location.reload();
          } else {
            next("/Home"); // 否则全部重定向到登录页
          }
          console.log("点击登录，弹出登录弹窗");
          store.commit("users/ADD_VISIBLE", true);
        })
        .catch(err => {
          next("/Home"); // 否则全部重定向到登录页
        });
      NProgress.done();
    }
  }
});

const getHasPermission = permissionIDs => {
  if (typeof permissionIDs === "string") permissionIDs = [permissionIDs];
  const list =
    store.getters.menuTree.map(x => {
      return x.meta && x.meta.PermissionID;
    }) || [];
  return !!list.some(x => permissionIDs.includes(x.PermissionID));
};



// WEBPACK FOOTER //
// ./src/permission.js